module.exports = __webpack_public_path__ + "img/logo.27e93a4c.webp";